jQuery( document ).ready( function($) {
  var $bestSlider = $('.best-slider');

  function resizeProductSlider($slider) {
    window.requestAnimationFrame(function() {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      } else if ($slider.hasClass('flickity-enabled')) {
        $slider.flickity('resize');
      }
    });
  }

  $(document).on('lazyloaded', '.best-slider img, .products-slider img', function() {
    resizeProductSlider($(this).closest('.best-slider, .products-slider'));
  });

  if ($.fn.slick) {
    $bestSlider.slick({
      dots: false,
      arrows: true,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<i class="fal fa-chevron-circle-left arrow-prev"></i>',
      nextArrow: '<i class="fal fa-chevron-circle-right arrow-next"></i>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  } else {
    $bestSlider.addClass('slick-unavailable');
  }

  $(window).on('load', function() {
    $('.best-slider, .products-slider').each(function() {
      resizeProductSlider($(this));
    });
  });

  if ($.fn.slick) {
    $('.testimonials-slider').slick({
      dots: false,
      arrows: false,
      autoplay: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '50px'
          }
        },
        {
          breakpoint: 431,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '50px'
          }
        }
      ]
    });
  }
  
  $('.hamburger').click(function(e) {
    $('.side-panel').addClass('open');      
    e.preventDefault();
  }); 
  
  $('.side-panel .close').click(function(e) {
    $('.side-panel').removeClass('open');      
    e.preventDefault();      
  });     
  
  $('.has-children').click(function(e) {
    var $this = $(this);
    var $children = $this.next('.children');
    
    // Toggle the clicked menu
    if ($this.hasClass('active')) {
      // If open, close it
      $this.removeClass('active');
      $children.slideUp();
    } else {
      // If closed, open it
      $this.addClass('active');
      $children.slideDown();
    }
    
    e.preventDefault();
  });    

  $('.faq-wrap .faq-title').click(function() {
    var $title = $(this);
    var $answer = $title.next('.faq-answer');
    var isActive = $title.hasClass('active');

    if (isActive) {
      $answer.slideUp().attr('aria-hidden', 'true');
      $title.removeClass('active').attr('aria-expanded', 'false');
    } else {
      $answer.slideDown().attr('aria-hidden', 'false');
      $title.addClass('active').attr('aria-expanded', 'true');
    }
  });
  
  // Search functionality for both desktop and mobile headers
  $('.open-search').click(function(e) {
    e.preventDefault();
    
    if ($(this).hasClass('active')) {
      $('.search-box').hide();
      $(this).removeClass('active');
      $(this).find('i').removeClass('fa-times').addClass('fa-search');
    } else {
      $('.search-box').show();
      $(this).addClass('active');        
      $(this).find('i').removeClass('fa-search').addClass('fa-times');
      $(this).closest('header').find('.search-box input[type="text"]').focus();
    }
  });

  /* ------ Sticky Header ----- */ 
  var header = $('#shopify-section-header-kmq').clone(true, true).addClass('sticky');
  
  $('body').append(header);

  var lastScrollTop = 0;
  $(window).scroll(function(event){
    var st = $(this).scrollTop();
    
    // Don't handle scroll events if search is active
    if ($('.open-search').hasClass('active')) {
      // But if we're scrolling to the top and sticky is visible, hide it to prevent duplicates
      if (st < 400 && $('#shopify-section-header-kmq.sticky').hasClass('run-sticky')) {
        $('#shopify-section-header-kmq.sticky').removeClass('run-sticky');
        // Don't return here, let the normal scroll logic continue
      } else {
        return; // Only return if we're not handling the duplicate menu case
      }
    }
    
    if (st > lastScrollTop){
      // downscroll code

      if ($(document).scrollTop() > 400) {          
        $('#shopify-section-header-kmq.sticky').addClass('run-sticky');
        $('#shopify-section-header-kmq.sticky').removeClass('delay-removal');
      }
    } else {
      if ($('#shopify-section-header-kmq.sticky').hasClass('run-sticky')) {
        $('#shopify-section-header-kmq.sticky').addClass('delay-removal');
      }

      $('#shopify-section-header-kmq.sticky').removeClass('run-sticky');

      $('.mega-menus').hide();
      $('.mega-menus .mega-menu').hide();
      $('.mega-menu-trigger').removeClass('active');
      $('.search-box').hide();
      $('.open-search').removeClass('active');
      $('.open-search i').removeClass('fa-times').addClass('fa-search');

      function explode() {
        $('#shopify-section-header-kmq.sticky').removeClass('delay-removal');
      }
      setTimeout(explode, 300);              
    }
    lastScrollTop = st;
  });

  // Header Mega Menu Functionality
  if ($('.site-header').length) {
    
    // Hide mega menus when any header link is hovered
    $('.site-header .header-main a').hover(function(){
      $('.mega-menus').hide();
      $('.mega-menus .mega-menu').hide();
      $('.mega-menu-trigger').removeClass('active');
    });
    
    $('.site-header .header-main a').keydown(function(){
      $('.mega-menus').hide();
      $('.mega-menus .mega-menu').hide();
      $('.mega-menu-trigger').removeClass('active');
    });
    
    // Mega menu hover functionality
    $('.mega-menu-trigger').hover(function() {
      showMegaMenu($(this));
    });

    $('.mega-menu-trigger').keydown(function() {
      showMegaMenu($(this));
    });
    
    // Hide mega menu when mouse leaves the entire header area
    $(document).mouseover(function(e) {
      var container = $('.site-header, .mega-menus');
      
      // If the target isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        hideMegaMenus();
      }
    });
    
    $(document).keydown(function(e) {
      var container = $('.site-header, .mega-menus');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        hideMegaMenus();
      }
      
      // Close search and mega menu on escape key
      if (e.keyCode === 27) { // Escape key
        $('.site-header .search-box').removeClass('active');
        $('.site-header .open-search i').removeClass('fa-times').addClass('fa-search');
        $('.mega-menus .mega-menu').removeClass('active');
        $('.mega-menus').hide();
      }
    });
    
    // Hide mega menu when clicking outside
    $(document).click(function(e) {
      if (!$(e.target).closest('.site-header, .mega-menus').length) {
        $('.mega-menus .mega-menu').removeClass('active');
        $('.mega-menus').hide();
      }
    });
  }
});  

// Add support for split test - March 6th 2025
window.addEventListener('ig:CartUpdated', () => {
  // call the theme's built in refreshCart method to handle updating cart item count in navbar
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    window.refreshCart(cart);
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
  });

  // if they are on the cart page reload to show the correct contents.
  if (window.location.pathname === '/cart') {
    window.location.reload();
  }
})

// ==================================================
// HELPER FUNCTIONS
// ==================================================

function showMegaMenu($trigger) {
  // Hide search when showing mega menu
  $('.search-box').hide();
  $('.open-search').removeClass('active');
  $('.open-search i').removeClass('fa-times').addClass('fa-search');
  
  var menuItem = $trigger.closest('.menu-item');
  var megaMenuId = menuItem.data('mega-menu');
  
  // Hide all mega menus first
  $('.mega-menus .mega-menu').removeClass('active');
  $('.mega-menus').hide();
  
  // Show current mega menu
  $('.mega-menus #' + megaMenuId).addClass('active');
  $('.mega-menus #' + megaMenuId).show();
  $('.mega-menus').show();
  $trigger.addClass('active');      
}

function hideMegaMenus() {
  $('.mega-menus .mega-menu').removeClass('active');
  $('.mega-menus').hide();
  $('.mega-menu-trigger').removeClass('active');
}

jQuery( document ).ready( function( $ ) {

  /* ------ Collections Filter ----- */ 

  $('[data-filter]').click(function(){
    $(this).toggleClass('filter-active');
    let filterActive = $('.filter-active');

    if(filterActive.length > 0){
      $('[data-filters]').removeClass('visible');
      filterActive.each(function(){
        let dataFilter = $(this).data('filter');
        $('[data-filters]').each(function(){
          let dataFilters = $(this).data('filters');
          if(dataFilters.indexOf(dataFilter) >= 0){
            $(this).addClass('visible');
          }
        })
      })
    } else{
      $('[data-filters]').addClass('visible');
    }
    
  });

  /* ------ Protein LP FQ ----- */ 

  $('.protein-faq ul li').click(function(){
    $('.protein-faq ul li').removeClass('open');

    $(this).addClass('open');
  });
});
